export default "__VITE_ASSET__ybanlWTC__"